import React from 'react';
import PropTypes from 'prop-types';
import { StarRatingDisplay } from '@nexus/fff-ratings-and-reviews';

import styles from './RatingsAndReviewsHeader.module.scss';

const RatingsAndReviewsHeader = ({ rating, count }) => (
  <div className={styles.header} data-testid="rate-and-review-header">
    <div className={styles.ratingTitle}>
      <h2>Reviews</h2>
      {rating > 0 && (
        <>
          <StarRatingDisplay
            rating={rating}
            ratingCount={count}
            theme="pink"
            size="large"
            showOnlyStars
          />
        </>
      )}
    </div>
    <div className={styles.ratingLabel}>
      <span>{`${rating} of 5 | ${count} Reviews`}</span>
    </div>
  </div>
);

RatingsAndReviewsHeader.propTypes = {
  rating: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
};

export default RatingsAndReviewsHeader;
